import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const ToggleSwitch = ({ checked, onChange }) => {
  const [internalOn, setInternalOn] = useState(false);

  const isControlled = checked !== undefined;
  const isOn = isControlled ? checked : internalOn;

  const handleClick = () => {
    if (isControlled) {
      onChange && onChange(!isOn);
    } else {
      setInternalOn(prev => !prev);
    }
  };

  return (
    <div className="toggle-container" onClick={handleClick}>
      <div className={`toggle-background ${isOn ? "on" : ""}`}>
        <div className={`toggle-circle ${isOn ? "on" : ""}`} />
      </div>
      <label style={{color:'#70707A',fontSize:'17px',marginBottom:'0px'}}>Show Inactive</label>
    </div>
  );
};

export default ToggleSwitch;
